import { createContext, useContext, useMemo } from 'react';
import { globalTracker } from '@/utils/track';

type TrackEvent = typeof globalTracker.track;

type TrackerContextValue = {
	track: TrackEvent;
};

const TrackerContext = createContext<TrackerContextValue>({
	track: globalTracker.track,
});

/**
 * use it to shared track function to all the children components
 * useful when a component/widget is used across funnels and athe parent funnel has common attributes and needed to be attached to the child events
 */
export function TrackerProvider({
	children,
	track,
}: {
	children: React.ReactNode;
	track: TrackerContextValue['track'];
}) {
	const value = useMemo(() => ({ track }), [track]);
	return (
		<TrackerContext.Provider value={value}>{children}</TrackerContext.Provider>
	);
}

export function useTracker() {
	return useContext(TrackerContext);
}
